import useGetApi from 'src/api/useGetApi';

export interface OrderfulEdiConfig {
  id: string;
  key: string;
  type: 'customer' | 'organization';
  customerId?: string;
  customerName?: string;
  createdAt: string;
  updatedAt: string;
}

interface OrderfulEdiConfigResponse {
  totalCount: number;
  start: number;
  length: number;
  configs: OrderfulEdiConfig[];
}

interface UseOrderfulEdiConfigsParams {
  type: 'customer' | 'organization';
  customerId?: string;
}

const useOrderfulEdiConfigs = ({
  type,
  customerId,
}: UseOrderfulEdiConfigsParams) => {
  return useGetApi<OrderfulEdiConfigResponse>({
    endpoint: 'erp-integrations/orderful-edi/configs/search',
    queryParameters: {
      type,
      ...(customerId ? { customerId } : {}),
    },
    options: {
      enabled: type === 'organization' || (type === 'customer' && !!customerId),
    },
  });
};

export default useOrderfulEdiConfigs;
